import { render } from "./icp.vue?vue&type=template&id=cdb596f6&scoped=true"
import script from "./icp.vue?vue&type=script&lang=js"
export * from "./icp.vue?vue&type=script&lang=js"

import "./icp.vue?vue&type=style&index=0&id=cdb596f6&scoped=true&lang=css"

import exportComponent from "/vuebuild/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdb596f6"]])

export default __exports__